<div class="grid menu" *ngIf="filterConfig.length > 0">
  <div class="col">
    <span class="p-input-icon-left">
      <i class="pi pi-filter"></i>
      <input type="text" [(ngModel)]="searchKey" pInputText placeholder="Filter (min 3 characters)"
        (ngModelChange)="onSearch($event)" (keyup.enter)="OnSearchEnter()" />
    </span>
  </div>
  <div class="col" *ngFor="let filter of filterConfig | slice:0:standardFilterCount">
    <p-multiSelect [virtualScroll]="filter.options && filter.options.length > 25" [virtualScrollItemSize]="40"
      [options]="filter.options" [placeholder]="filter.displayName" optionLabel="name" optionValue="value"
      [displaySelectedLabel]="true" [maxSelectedLabels]="1" [selectedItemsLabel]="'{0} items selected'"
      class="filter w-full" [(ngModel)]="selectedFilterItems[filter.fieldName]"
      (onChange)="onFilterChange(filter.fieldName, $event.value)" [resetFilterOnHide]="true">
      <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick type="button" label="Clear" styleClass="p-button-text" icon="pi pi-times"
          (debounceClick)="clearFilter(filter.fieldName)"></p-button>
      </ng-template>
    </p-multiSelect>
  </div>
  <div class="col justify-content-end">
    <button *ngIf="filterConfig.length > standardFilterCount" appPreventDoubleClick pButton type="button"
      id="panel_moreFilters_{{ showMoreFilters ? 'show' : 'hide' }}"
      [icon]="showMoreFilters ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down'"
      [pTooltip]="showMoreFilters ? 'Show Less' : 'More'" (debounceClick)="showMoreFilters = !showMoreFilters"
      class="p-button-outlined p-button-text p-button-info"></button>

    <p-button appPreventDoubleClick type="button" styleClass="p-button-rounded p-button-info p-button-outlined ml-1"
      [icon]="'pi pi-search'" (debounceClick)="applyFilters()"
      pTooltip="Apply Filters"></p-button>

    <p-button appPreventDoubleClick type="button" styleClass="p-button-text p-button-rounded ml-1"
      icon="pi pi-times" (debounceClick)="clearAllFilters()" pTooltip="Clear All Filters"></p-button>
  </div>

  <div class="grid mb-0 ml-2 min-w-full" *ngIf="showMoreFilters">
    <div class="col-2 ml-3" *ngFor="let filter of filterConfig | slice:standardFilterCount">
      <p-multiSelect [virtualScroll]="filter.options && filter.options.length > 25" [virtualScrollItemSize]="40"
        [options]="filter.options" [placeholder]="filter.displayName" optionLabel="name" optionValue="value"
        [displaySelectedLabel]="true" [maxSelectedLabels]="1" [selectedItemsLabel]="'{0} items selected'"
        class="filter w-full" [(ngModel)]="selectedFilterItems[filter.fieldName]"
        (onChange)="onFilterChange(filter.fieldName, $event.value)" [resetFilterOnHide]="true">
        <ng-template pTemplate="footer">
          <p-button appPreventDoubleClick type="button" label="Clear" styleClass="p-button-text" icon="pi pi-times"
            (debounceClick)="clearFilter(filter.fieldName)"></p-button>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>
</div>